import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase } from 't4core';
import { EmailTemplateInfo, ItemInfo, T4ServiceService } from "../../../../../projects/t4core/src/public-api";
import { T4_ServiceDialog } from "../serviceDialog/serviceDialog";


@Component({
  styleUrls: ['./pdfServiceDialog.css'],
  selector: 'pdf-service-dialog',
  templateUrl: 'pdfServiceDialog.html',
})

export class PdfServiceDialog extends DialogBase implements OnInit {

  public templates: EmailTemplateInfo[] = [];

  public text: string = "";

  constructor(
    public dialogRef: MatDialogRef<T4_ServiceDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    super("PdfServiceDialog");

    if (data != null) {

    }
  }


  async ngOnInit(){

    await this.getTemplates();
    
    console.log(this.templates);
  }

  public async getTemplates() {
    this.templates = await this.Api.get<EmailTemplateInfo[]>("Settings/GetContentTemplatesByKey", { type: 2, key: "T4.ServiceDialog.Document.PoliceTemplate" });
  }

 public async onTemplateChange(template: string) {
    this.text = await this.formatText(template);
  }


  public async formatText(template: string) {
    if (!template) return '';

    return template.replace(/\$\{(.*?)\}/g, (_, expression) => {
      try {
        // Remove "this.data." if present
        const cleaned = expression.trim().replace(/^this\.data\./, '');

        // Resolve value (supports nested)
        const value = cleaned
          .split('.')
          .reduce((obj, key) => obj?.[key], this.data);

        //Removes * from reg no as such.
        return (value ?? '')
          .toString()
          .replace(/\*/g, '');

      } catch {
        return '';
      }
    });
  }

  close() {
    this.dialogRef.close();
  }

  openPdf(): void {
    const popup = window.open('', '_blank');
    if (!popup) return;

    // Convert line breaks, but KEEP HTML tags
    const formattedText = this.text.replace(/\n/g, '<br>');

    popup.document.write(`
    <html>
      <head>
        <style>
          @page {
            size: A4;
            margin: 12mm;
          }

          html, body {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            line-height: 1.6;
          }

          body {
            padding: 12mm;
            box-sizing: border-box;
          }
        </style>
      </head>
      <body>
        ${formattedText}
        <script>
          window.onload = function() {
            window.print();
          };
        </script>
      </body>
    </html>
  `);

    popup.document.close();
  }


}
